import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, TemplateRef, VERSION, ViewChild} from '@angular/core';
import {ZXingScannerComponent} from '@zxing/ngx-scanner';
import { Result } from '@zxing/library';
import {AuthService} from '../services/auth.service';
import {AngularFireDatabase} from 'angularfire2/database';
import {Observable, Subscription} from 'rxjs';
import {FamilyService} from '../services/family.service';
import {environment} from '../../environments/environment';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalDirective, TypeaheadMatch} from 'ngx-bootstrap';
import {FormControl, FormGroup, NgControl} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GradoService } from '../services/grado.service';
import { take } from 'rxjs/operators';



@Component({
  selector: 'app-family',
  templateUrl: './family.component.html',
  styleUrls: ['./family.component.scss']
})
export class FamilyComponent implements OnDestroy, AfterViewInit {

  public formSearch: FormGroup;
  public appReady: boolean;

  ngVersion = VERSION.full;

  @ViewChild('scanner')
  scanner: ZXingScannerComponent;
  items: Observable<any[]>;
  list: Observable<any[]>;
  @ViewChild(ModalDirective) modal: ModalDirective;
  @ViewChild('inputSearcher')
  inputSearcher: ElementRef;
  @ViewChild(ModalDirective) noConnection: ModalDirective;


  disabled: boolean;
  calculated: boolean;
  hasDevices: boolean;
  surname: string;
  familiaSelected: string;
  hasPermission: boolean;
  lostConection = false;
  qrResultString: string;
  qrResult: Result;
  existFamily = false;
  family: Observable<any>;
  keyRetirado: any;
  public listUsers: Array<any> = [];
  public listUsersFounded: Array<any> = [];
	children: any;
	otroschildren: Array<any> = [];
	grado = '7';
	gradoSymbol = '';
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo;
  config: ModalOptions;
  routeSubscription: Subscription;
  findChildrenSubscription: Subscription;
  isDisabledSubscription: Subscription;
  familySubscription: Subscription;
  getStatusAppSubscription: Subscription;
  conecSubs$: Subscription;
  constructor(
    public db: AngularFireDatabase,
    private familyService: FamilyService,
    private modalService: BsModalService,
    private gradoService: GradoService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.formSearch = new FormGroup({
      'searcher': new FormControl('')
    });
  }

  ngAfterViewInit(): void {
    this.loadModal();
    this.allFamilies();
    // TODO
    this.cargarOtherChildrenOfFamily();
  }

  cargarOtherChildrenOfFamily(){

  }

  loadModal(){
    this.lostConection = false;
    this.modal.show();
    this.getStatusAppSubscription = this.familyService.getStatusApp().subscribe(status => {
        this.appReady = status
    })

    this.routeSubscription = this.activatedRoute.params.subscribe( params => {
      // @param id
      const family = params['id'];
      this.findChildrenSubscription = this.familyService.findChildren(family).subscribe(children => {
        console.log('Read children:', children)
        this.children = children;
        this.surname = this.children[0].nombre.split(',')[0];
        this.familiaSelected = family;
        this.children.forEach((child, index) => {
          this.isDisabled(index, child.retirado);
          child.checked = !!child.retirado;
        });
      });
    });
  }

  stateToEmoji(state: boolean): string {

    const states = {
      // not checked
      undefined: '❔',
      // failed to check
      null: '⭕',
      // success
      true: '✔',
      // can't touch that
      false: '❌'
    };

    return states['' + state];
  }

  callAlumnoByGroup(children) {
    this.lostConection = false;
    if(this.routeSubscription) this.routeSubscription.unsubscribe();
    if(this.findChildrenSubscription) this.findChildrenSubscription.unsubscribe();
    if(this.isDisabledSubscription) this.isDisabledSubscription.unsubscribe();
    if(this.conecSubs$) this.conecSubs$.unsubscribe();
    this.conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          children.forEach(child => {
            console.log('Child tildado OK', child)
            if (child.checked && !child.isDisabled) {
              this.callAlumno(child.key, child.grado, child.nombre);
            }
          });

          this.modal.hide();
          if(this.routeSubscription) this.routeSubscription.unsubscribe();
          if(this.findChildrenSubscription) this.findChildrenSubscription.unsubscribe();
          if(this.isDisabledSubscription) this.isDisabledSubscription.unsubscribe();
          if(this.conecSubs$) this.conecSubs$.unsubscribe();

          setTimeout(() => {
            this.loadModal();
          },5000)
        } else {
          this.lostConection = true;
          setTimeout(() => {
            this.lostConection = false;
          }, 2000);
        }
      }
    );
  }


  callAlumno(key, grado, nombre){
    console.log('callAlumno', {key, grado, nombre})
   this.familyService.confirmRetirado(key, grado, nombre, this.familiaSelected);
 }

 callAlumnoByOtherFamily(key, grado, nombre, familia){
  this.familyService.confirmRetiradoPorOtraFamilia(key, grado, nombre,familia, this.familiaSelected, this.surname);
  this.otroschildren.forEach((item) => {
    if (nombre === item.nombre) {
      item.retirado = true;
    }
  });
 }

  allFamilies(): void {
    this.familyService.findAlumnos().pipe(take(1)).subscribe(snapshots => {
      this.listUsers = snapshots;
    });
  }

  searchFamily(ev: any): void {
    const value = ev['target']['value'];
    this.listUsersFounded = this.listUsers.filter(word => (word.nombre).toLowerCase().indexOf(value.toLowerCase()) > -1);
  }

  public onSelectedUser(ev: TypeaheadMatch): void {
    this.lostConection = false;
    console.log('ev', ev)
    this.inputSearcher.nativeElement.value = '';
    if(this.familySubscription) this.familySubscription.unsubscribe();
    const conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          this.familyService.findChildren(ev.item.familia).pipe(take(1)).subscribe(
            (otroschildren) => {
              if(!this.otroschildren.some(c => c.nombre === ev.item.nombre)){
                const newChild = otroschildren.find(c => c.nombre && c.nombre === ev.item.nombre)
                ev.item['key'] = newChild.key
                this.otroschildren.push(ev.item);
              }
              this.otroschildren.forEach((child, index) => {
                this.isDisabled(index, child.retirado);
                child.checked = true;
              });
            }
          );
        }
        this.modal.show();
        conecSubs$.unsubscribe();
      });
  }

  checkAlumno(index) {
    this.children.forEach((child, index2) => {
      if(index === index2) {
        child.checked = !child.checked;
      }
    });
  }

  resetAlumno(nombre, key, grado) {
    this.lostConection = false;
    const conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          this.familyService.removeFromGradoAndAll(nombre, grado);
          this.familyService.resetStateInFamily(this.familiaSelected, key);
        } else {
          this.lostConection = true;
          setTimeout(() => {
            this.lostConection = false;
          }, 2000);
        }
        conecSubs$.unsubscribe();
      });
  }

  resetAlumnoByOtherFamily(nombre, key, grado, familia) {
    this.lostConection = false;
    const conecSubs$ = this.db.object('.info/connected').valueChanges().subscribe(
      connected => {
        if (connected) {
          this.familyService.removeFromGradoAndAll(nombre, grado);
          this.familyService.resetStateInFamily(familia, key);

          this.otroschildren.forEach((item) => {
            if (nombre === item.nombre) {
              item.retirado = false;
            }
          });
        } else {
          this.lostConection = true;
          setTimeout(() => {
            this.lostConection = false;
          }, 2000);
        }
        conecSubs$.unsubscribe();
      });
  }


  public isDisabled(index2, key: string): void {
    this.isDisabledSubscription = this.familyService.isDisabled(key).subscribe(
      resp => {
        this.children.forEach((item, index) => {
          if (index === index2) {
            item.isDisabled = resp && resp.retirado ? resp.retirado : false;
          }
        });
      }
    );

  }

  ngOnDestroy(){
    if(this.routeSubscription) this.routeSubscription.unsubscribe();
    if(this.findChildrenSubscription) this.findChildrenSubscription.unsubscribe();
    if(this.isDisabledSubscription) this.isDisabledSubscription.unsubscribe();
    if(this.conecSubs$) this.conecSubs$.unsubscribe();
    if(this.familySubscription) this.familySubscription.unsubscribe();
    if(this.getStatusAppSubscription) this.getStatusAppSubscription.unsubscribe();
  }
}
